/*
 * Preserve the line breaks supplied in Shopify product descriptions.
 * This changes storefront presentation only; no product data is modified.
 */
(() => {
  const preserveLineBreaks = (description) => {
    if (description.dataset.orLineBreaksProcessed === 'true') return;

    const textNodes = [];
    const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      const textNode = walker.currentNode;
      if (/\S/.test(textNode.nodeValue || '') && /\r?\n/.test(textNode.nodeValue || '')) {
        textNodes.push(textNode);
      }
    }

    textNodes.forEach((textNode) => {
      const parts = (textNode.nodeValue || '').split(/\r?\n/);
      const fragment = document.createDocumentFragment();

      parts.forEach((part, index) => {
        if (index > 0) fragment.append(document.createElement('br'));
        if (part) fragment.append(document.createTextNode(part));
      });

      textNode.replaceWith(fragment);
    });

    description.dataset.orLineBreaksProcessed = 'true';
  };

  document.querySelectorAll('[data-or-product-description]').forEach(preserveLineBreaks);
})();
